module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Polizia.d599c9df.svg";